import { render } from "./GeneraFattureClientiEnergia.vue?vue&type=template&id=273ea514&scoped=true"
import script from "./GeneraFattureClientiEnergia.vue?vue&type=script&lang=js"
export * from "./GeneraFattureClientiEnergia.vue?vue&type=script&lang=js"

import "./GeneraFattureClientiEnergia.vue?vue&type=style&index=0&id=273ea514&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273ea514"]])

export default __exports__